export default class ModelsUtil {

    static checkCreateField(column) {
        let accessorKey = column.id;
        return !(accessorKey === 'id' || accessorKey === 'header.name' || accessorKey === "basicModel.name" || accessorKey === 'enabled'
            || accessorKey === 'packagingSet.articleNumber');
    }
}